<template>
<div class="page" :style="{ background:colors.coral }">
  <top-bar fixed />

  <!-- ToC / Index Links -->

  <section class="location-section istanbul-location" :style="{ paddingTop: '120px' }">
      <vector-canvas
        vector="MaidensTower"
        class="location-art istanbul-location__image"
        :color="colors.coralDark"
        align-x="mid"
        align-y="max"
        scale="cover"
        fit-parent
        />
      
      <!-- v-parallax="0.2" -->
      <date-block
        :month="$t('month-june')"
        :day="16"
        :city="$t('istanbul')"
        :location="$t('turkey')"
        :fg="colors.coral"
        :bg="colors.paleYellow"
        class="location-date"
        />
      
      <div class="istanbul-right-float">
        <button-block
          :label="$t('rsvp')"
          :fg="colors.coral"
          :bg="colors.paleYellow"
          v-on:click="$router.push('rsvp')"
          />
      
        <button-block
          :label="$t('travelGuide')"
          :fg="colors.coral"
          :bg="colors.paleYellow"
          v-on:click="$router.push('istanbul/guide')"
          />
      </div>
      
  </section>

  <section>
    <mapbox-block
      :center="[29.001632251272554, 41.017161111399616]"
      :zoom="12.5"
      :style="{ height:'400px' }"
      :interactive="false"
      />

      <!-- address on paper card + google link -->
      <paper-card
        :style="{ position: 'absolute', right: '20%', bottom: '25%' }"
        >
          <h3>{{ $t('istanbul') }}, {{ $t('turkey') }}</h3>
          <h3>{{ $t('maidens-tower') }}</h3>
          <button-link 
            :label="$t('map-link')"
            @click="openUrlInTab('https://www.google.com/maps/place/Maiden\'s+Tower/@41.0211216,29.0041105,15z/data=!4m5!3m4!1s0x0:0x6ed7f4baceb4476c!8m2!3d41.0211216!4d29.0041105')"
            :fg="colors.coral"
            />
      </paper-card>
  </section>

  <section class="details-section" :style="{ color: colors.paleYellow }">
    <!-- 
    <h2>Schedule</h2>
    start / end / dinner times in a table
    <hr/>
    -->

    <h2>{{$t('boats')}}</h2>
    <table>
      <tr>
        <td>{{$t('kabatas')}}</td>
        <td>{{$t('kabatas-times')}}</td>
      </tr>
      <tr>
        <td>{{$t('salacak')}}</td>
        <td>{{$t('salacak-times')}}</td>
      </tr>
    </table>
  </section>

  <section class="details-section" :style="{ color: colors.paleYellow, backgroundColor: colors.indigoDark, padding: '20px;' }">
    <h2>{{$t('henna-night')}}</h2>

    <!-- AT: -->
    <h3>{{$t('henna-night-time')}}</h3>

    <!-- ADDRESS: -->
    <div>
    {{$t('henna-night-address-1')}}<br/>
    {{$t('henna-night-address-2')}}<br/>
    {{$t('henna-night-address-3')}}<br/>
    <button-link 
        :label="$t('map-link')"
        @click="openUrlInTab('https://www.google.com/maps/place/Latife+Ata%C5%9Fehir+K%C4%B1na+Salonu/@40.9938037,29.0990804,17z/data=!3m1!4b1!4m5!3m4!1s0x14cac628d89dc54f:0xa56c23d7889940f1!8m2!3d40.9938037!4d29.1012691')"
        :fg="colors.coral"
        />
    </div>
  </section>

  <!--section class="details-section" :style="{ padding: '20px;' }">
    <h2>Travel Tips FAQ</h2>
  </section-->
</div>
</template>

<script>
// @ is an alias to /src
import DateBlock from '@/components/DateBlock.vue'
import ButtonBlock from '@/components/ButtonBlock.vue'
import ButtonLink from '@/components/ButtonLink.vue'
import TopBar from '@/components/TopBar.vue'
import VectorCanvas from '@/components/VectorCanvas.vue'
import { colors } from '@/colors.js'
import MapboxBlock from '@/components/MapboxBlock.vue'
import PaperCard from '@/components/PaperCard.vue'

export default {
  name: 'istanbul',
  components: {
      DateBlock,
      ButtonBlock,
      ButtonLink,
      TopBar,
      VectorCanvas,
      MapboxBlock,
      PaperCard,
  },
  data () {
    return {
      colors
    }
  },
  methods: {
    openUrlInTab (url) {
      const win = window.open(url, '_blank');
      win.focus();
    }
  }
}
</script>

<style>
.istanbul-right-float {
    z-index: 7000;
    width: 360px;
    position: absolute;
    right: 10%;
    top: 20%;
    height: 55px;
    overflow: visible;
    padding: 40px;
}
.istanbul-right-float > * {
      margin-bottom: 15px;
}
@media (max-width: 700px) {
  .istanbul-right-float {
    position: relative;
    width: auto;
    right: auto;
    top: auto;
    height: auto;
    padding: initial;
    align-self: stretch;
  }
}
</style>
